// HoverTrigger.ts
// Mirrors ConneXt v2 HoveredTrigger: hover-based trigger with RepeatableOnArticle + RepeatableOnConversation.
import { BaseTrigger } from "./BaseTrigger";
export class HoverTrigger extends BaseTrigger {
    constructor() {
        super(...arguments);
        this.hasActionTriggerLimit = false;
        this.handler = null;
        this.element = null;
    }
    get selector() {
        return this.when.Selector || "";
    }
    get includeChildren() {
        var _a, _b;
        return (_b = (_a = this.when.IncludeChildren) !== null && _a !== void 0 ? _a : this.when.IncChild) !== null && _b !== void 0 ? _b : false;
    }
    init() {
        if (!this.selector)
            return;
        this.element = document.querySelector(this.selector);
        if (!this.element)
            return;
        this.handler = (e) => this.hoverTrigger(e);
        this.element.addEventListener("mouseover", this.handler);
    }
    hoverTrigger(e) {
        if (this.canTrigger()) {
            if (!this.includeChildren && e.target !== this.element) {
                e.stopPropagation();
                return;
            }
            if (!this.timer) {
                this.startTimer(() => {
                    clearTimeout(this.timer);
                    this.timer = null;
                    this.markTriggered();
                    this.actionInstance.execute();
                });
            }
        }
        else if (!this.hasActionTriggerLimit) {
            this.hasActionTriggerLimit = true;
        }
    }
    unRegister() {
        super.unRegister();
        if (this.element && this.handler) {
            this.element.removeEventListener("mouseover", this.handler);
        }
    }
}
